// Created: 2026-07-31
// Updated: 2026-07-31
//
// Tombstone helpers for the read side (content-lifecycle-and-deletion, task 14.5 / Req 3.1-3.4).
//
// A user-deleted item is retained, not hard-deleted: detail reads resolve to a 200 tombstone object
// (`{ <id>, tombstoned: true, message }`) rather than a dead 404, and by-id reference/listing
// surfaces carry an optional `tombstoned` flag on the enriched record. This helper reads that flag off
// any response shape without every caller having to widen its own type.

/** True when a read response (detail or reference) represents a "removed by author" tombstone. */
export function isTombstoned(value: unknown): boolean {
  return typeof value === 'object' && value !== null && (value as { tombstoned?: unknown }).tombstoned === true
}
